import type { TipProiect } from "../api";
import { useT } from "../i18n";
import { PAL } from "../structure/paletaDesen";

/** Semnul mic al tipului de proiect. Complet: trei straturi, cel de sus în
 *  accent — clădirea întreagă, disciplină peste disciplină. Structură: un
 *  cadru în culorile structurii, doi stâlpi, două grinzi și un perete. */
export function IconTip({ tip, s = 16 }: { tip: TipProiect; s?: number }) {
  if (tip === "structura") {
    return (
      <svg width={s} height={s} viewBox="0 0 16 16" aria-hidden="true" className="icon-tip">
        <path d="M6.9 9.3h2.2V14H6.9z" fill={PAL.pereteBeton} opacity=".85" />
        <path d="M3.5 14V2.5M12.5 14V2.5" stroke={PAL.stalp} strokeWidth={1.7}
              strokeLinecap="round" fill="none" />
        <path d="M3.5 3.2h9M3.5 8.5h9" stroke={PAL.grinda} strokeWidth={1.3}
              strokeLinecap="round" fill="none" />
      </svg>
    );
  }
  return (
    <svg width={s} height={s} viewBox="0 0 16 16" aria-hidden="true" className="icon-tip">
      <path d="M2 10.6 8 13.6 14 10.6M2 7.8 8 10.8 14 7.8" fill="none" stroke="var(--mut)"
            strokeWidth={1.2} strokeLinejoin="round" strokeLinecap="round" />
      <path d="M8 2 14 5 8 8 2 5Z" fill="var(--accbg)" stroke="var(--acc)" strokeWidth={1.2}
            strokeLinejoin="round" />
    </svg>
  );
}

/** Tipul proiectului, lângă numele lui: «Proiect complet» / «Proiect de
 *  structură». De el atârnă ce cere dosarul și ce pași urmează, deci se vede
 *  acolo unde se urcă actele. */
export default function EtichetaTip({ tip }: { tip: TipProiect }) {
  const t = useT();
  return (
    <span className="eticheta-tip"><IconTip tip={tip} />{t(`tip.${tip}`)}</span>
  );
}
